module.exports = __webpack_public_path__ + "img/8.685e479a.png";